import { ButtonIcon } from 'ui/components/primitives';
import { theme, styled } from 'ui/theme';

const Button = {
  Cta: styled(ButtonIcon)`
    background: ${theme.colors.action.navigation.standard.static};
    border: none;
    color: ${theme.colors.build.lightLight};
    grid-gap: ${theme.space[3]};
    padding: ${theme.space[5]};
  `,

  Space: styled('div')`
    padding-top: ${theme.space[12]};
  `,

  Wrapper: styled('div')`
    background: ${theme.colors.build.lightLight};
    bottom: 0;
    position: fixed;
    width: 100%;
  `,
};

export default Button;
